import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { ApolloProvider } from '@apollo/client';
import apolloClient from 'libs/apollo/apollo.lib';
import storage from 'libs/storage';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

import Layout from './layout';
import userStore from 'stores/user.store';
import { loadTheme } from 'libs/theme/theme.service';

//Pages
import Auth from 'pages/auth';

import 'App.scss';

setupIonicReact({});

const App = () => {
  const isAuthenticated = userStore.getIsAuthenticated();
  const checkAuth = async () => {
    userStore.setIsAuthenticating(true);
    try {
      await userStore.checkAuth();
      userStore.setIsAuthenticating(false);
    } catch (error) {
      userStore.setIsAuthenticating(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      await storage.create();
      
      // Load theme from API
      try {
        await loadTheme();
      } catch (error) {
        console.warn('Failed to load theme from API, using default theme');
      }
      
      await checkAuth();
    };
    init();
  }, []);

  return (
    <IonApp style={{ maxWidth: '430px', margin: '0 auto', backgroundColor: 'var(--ion-background-color)', border:'1px solid black' }}>
      <IonReactRouter>
        <ApolloProvider client={apolloClient}>
          <Layout>
            <IonRouterOutlet id='main'>
              <Route path='/login' exact component={Auth}>
                {isAuthenticated ? <Redirect to='/dashboard' /> : ''}
              </Route>
            </IonRouterOutlet>
          </Layout>
        </ApolloProvider>
      </IonReactRouter>
    </IonApp>
  );
};


export default observer(App);
